import { jsonToXlsx } from '@/utils/xlsExport/jsonToXlsx';
import { affiliatesColumns } from './affiliatePayment/modal/staticData';
import staticDataEntry from './affiliateEntries/staticDataEntry';
import { pickOrderObj } from '@/utils/functions';
import i18n from '@/plugins/i18n';
import { formatFloat, formatDateTime, formatFloatPositive } from '@/utils/functions';
import moment from 'moment';

export const exportXls = (data) => {
  const cols = affiliatesColumns();
  jsonToXlsx({
    name: `${i18n.t('Affiliate Report')} - ${moment().format('DD-MM-YYYY HH:mm')}`,
    headers: cols.map((c) => c.label),
    data: data.map((item) => {
      item.active_customers_count = parseInt(item?.active_customers_count || 0);
      item.reward_accumulative = formatFloatPositive(item?.reward_accumulative);
      item.reward_mark_count = parseInt(item?.reward_mark_count || 0);
      item.reward_mark = formatFloatPositive(item?.reward_mark);
      item.reward_total = formatFloatPositive(item?.reward_total);
      item.reward_mark_count = parseInt(item?.reward_mark_count || 0);
      item.reward_mark = formatFloatPositive(item?.reward_mark);
      item.reward_accumulative = formatFloatPositive(item?.reward_accumulative);
      item.gross_value = formatFloatPositive(item?.gross_value);
      item.admin_fee = formatFloatPositive(item?.admin_fee);
      item.reward_total = formatFloatPositive(item?.reward_total);

      return pickOrderObj(
        item,
        cols.map((c) => c.key)
      );
    })
  });
};

export const exportXlsEntry = (data) => {
  const cols = staticDataEntry().columns;
  jsonToXlsx({
    name: `${i18n.t('Affiliate Entries Report')} - ${moment().format('DD-MM-YYYY HH:mm')}`,
    headers: cols.map((c) => c.label),
    data: data.map((item) => {
      item.entry_value = formatFloat(item?.entry_value);
      item.entry_created_at = formatDateTime(item.entry_created_at);
      item.updated_at = formatDateTime(item.updated_at);

      return pickOrderObj(
        item,
        cols.map((c) => c.key)
      );
    })
  });
};
